<!--
* UIID: UI-DLB-ID-110, 120
* UI Name: Add Identification
* Modify Date: 2020/06/18
-->
<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display add-map-layout-dialog"
  >
    <template v-slot:title>
      <!-- [S]  Popup title-->
      <v-card-title class="headline white--text" primary-title
        >{{ options.item.isEdit ? 'Modify' : 'Add' }} Identification</v-card-title
      >
    </template>
    <template v-slot:button-close>
      <!-- <v-icon class="ma-2" small @click="removeDialog" color="white">fas fa-times</v-icon> -->
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <v-card class="v-dialog-1">
      <!-- [S]  Popup body-->
      <v-card-text class="pa-0">
        <v-form ref="form" class="dialog-content form-identification">
          <v-row v-if="indexType === -1" class="ml-0 mr-0 mb-1">
            <v-col cols="12" class="pa-0">
              <v-label>
                <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
                {{ $t('lbl.identification.type') }}
              </v-label>
              <v-select
                solo
                v-model="type"
                :items="typeList"
                :rules="[validationUtils.required]"
                @change="selectType()"
              ></v-select>
            </v-col>
          </v-row>
          <v-row v-if="type === 'P'" class="ml-0 mr-0 mb-1">
            <v-col cols="12" class="pa-0">
              <v-label>
                <v-icon v-if="indexType === -1" x-small class="mr-1">fa fa-asterisk</v-icon>
                {{ $t('lbl.identification.partner') }}
              </v-label>
              <v-select
                v-if="indexType === -1"
                solo
                v-model="prnr_ID"
                :items="prnrList"
                :rules="[validationUtils.required]"
                @change="selectComp()"
                :disabled="!!partnerId"
              ></v-select>
              <v-text-field
                v-if="indexType !== -1"
                :value="paramItem.prnrNm + ' (' + this.paramItem.prnrId + ')'"
                readonly
                solo
                :disabled="!$auth.manage"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="type === 'C'" class="ml-0 mr-0 mb-1">
            <v-col cols="12" class="pa-0">
              <v-label>
                <v-icon v-if="indexType === -1" x-small class="mr-1">fa fa-asterisk</v-icon>
                {{ $t('lbl.identification.company') }}
              </v-label>
              <v-select
                v-if="indexType === -1"
                solo
                v-model="comp_ID"
                :items="compList"
                :rules="[validationUtils.required]"
                @change="selectComp()"
                :disabled="!!partnerId"
              ></v-select>
              <v-text-field
                v-if="indexType !== -1"
                :value="paramItem.compNm + ' (' + this.paramItem.compId + ')'"
                readonly
                solo
                :disabled="!$auth.manage"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ml-0 mr-0 mb-1">
            <v-col cols="9" class="pa-0">
              <v-label>
                <v-icon v-if="indexType == -1 || !numOfUse" x-small class="mr-1"
                  >fa fa-asterisk</v-icon
                >
                {{ $t('lbl.identification.ediSR') }}
              </v-label>
              <v-text-field
                v-if="indexType == -1"
                ref="sr_id"
                v-model="editedItem.srId"
                :rules="[validationUtils.required, validationUtils.max(50)]"
                solo
              ></v-text-field>
              <v-text-field
                v-if="indexType != -1"
                ref="sr_id"
                v-model="editedItem.srId"
                :rules="[validationUtils.required, validationUtils.max(50)]"
                solo
                :disabled="!$auth.manage || this.numOfUse"
              ></v-text-field>
            </v-col>
            <v-col cols="3" class="pl-1 pa-0">
              <v-label>{{ $t('lbl.identification.qual') }}</v-label>
              <v-text-field
                ref="sr_qlfr"
                v-model="editedItem.srQlfr"
                :rules="
                  editedItem.srQlfr && editedItem.srQlfr.length > 0 ? [validationUtils.max(50)] : []
                "
                solo
                :disabled="!$auth.manage"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ml-0 mr-0">
            <v-col cols="12" class="pa-0">
              <v-label> <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Remark </v-label>
              <v-textarea
                ref="remark"
                v-model="editedItem.remark"
                counter="200"
                solo
                height="60"
                :rules="[validationUtils.required, validationUtils.max(200)]"
                :disabled="!$auth.manage"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
        <!-- [E]  Popup body-->
        <v-divider class="ml-0 mr-0 mt-6 divder-popup" inset></v-divider>
        <!-- [S]  Button Group-->
        <v-row class="ml-0 mr-0">
          <v-col class="button-col action-col" lg="12">
            <div class="btn-form-control text-right">
              <v-btn class="btn btn-popup btn-delete" @click="removeDialog">{{
                $t('btn.common.close')
              }}</v-btn>
              <v-btn
                class="btn btn-popup btn-popup-search"
                color="primary"
                @click="onSave"
                :disabled="!$auth.manage"
                >{{ $t('btn.common.save') }}</v-btn
              >
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Button Group-->
      <dialogWindow
        ref="ediIdDialog"
        size="max"
        :info="checkDialogTitle"
        :detail="checkDialogInfo"
        :color="checkDialogColor"
        @select-ok="removeDialog({})"
      ></dialogWindow>
    </v-card>
  </dialog-drag>
</template>

<script>
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag2.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';

export default {
  components: {
    DialogDrag,
    dialogWindow,
    IconSvg,
  },
  name: 'add-identification-dialog',
  // props: ['id', 'title', 'options', 'eventCb', 'closeDialog', 'dragStart', 'dragEnd', "indexType", "refeshList", "paramItem"],
  props: {
    id: String,
    title: String,
    options: Object,
    eventCb: Function,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    indexType: Number,
    refeshList: Function,
    paramItem: Object,
    partnerId: String,
  },
  data() {
    return {
      prnrList: [],
      compList: [],
      type: 'C',
      typeList: [
        { text: 'Company', value: 'C' },
        { text: 'Partner', value: 'P' },
      ],
      comp_ID: '',
      prnr_ID: '',
      checkDialogColor: 'warning',
      checkDialogTitle: '',
      checkDialogInfo: '',
      // 2021.5.27 203728 SPKA-123 remove default ZZZ
      editedItem: {
        srId: '',
        srQlfr: '',
        compId: '',
        remark: '',
      },
      srIdOrigin: '',
      srQlfrLoad: '',
      remarkOrigin: '',
      numOfUse: false,
    };
  },

  methods: {
    selectType() {
      this.comp_ID = '';
      this.prnr_ID = '';
    },
    focusInvalid() {
      let self = this;
      setTimeout(() => {
        self.$refs.sr_id.focus();
      }, 600);
    },
    removeDialog(dialog) {
      if (this.$refs.ediIdDialog.dialog && this.checkDialogColor === 'error') {
        this.$refs.ediIdDialog.dialog = false;
      } else {
        dialog.id = this.id;
        this.closeDialog(dialog);
        if (dialog && dialog.reload) {
          this.$emit('search');
        }
      }
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    async sendActivate(comId, comTp, info) {
      const params = {
        comId: comId,
        comTp: comTp,
        info: info,
      };
      await this.$store.dispatch('updateParnertProcessInfo', params);
    },
    selectComp() {
      if (this.type === 'P') {
        this.prnrList.forEach((element) => {
          if (this.prnr_ID === element.prnrId) {
            this.editedItem.ownrId = element.ownrId;
            this.editedItem.prnrId = element.prnrId;
          }
        });
      } else {
        this.compList.forEach((element) => {
          if (this.comp_ID === element.compId) {
            this.editedItem.ownrId = element.ownrId;
            this.editedItem.compId = element.compId;
          }
        });
      }
    },

    async onSave() {
      let validResult = this.$refs.form.validate();
      if (validResult) {
        if (this.indexType > -1) {
          let check = false;

          await this.$store.dispatch('checkEdiId', this.editedItem).then(() => {
            const checkResult = this.$store.getters.chkEdiId;
            if (checkResult.srId !== undefined) {
              this.$refs.ediIdDialog.dialog = true;
              this.checkDialogColor = 'error';
              this.checkDialogInfo = 'This identification is duplicated.';
              check = true;
            }
          });
          if (!check) {
            this.$store.dispatch('updateEdiId', this.editedItem).then(async () => {
              let editedField = {};
              editedField['id'] = this.editedItem.id;
              if (this.srQlfrLoad !== this.editedItem.srQlfr) {
                editedField['codeQualifier'] = this.editedItem.srQlfr;
              }
              if (this.remarkOrigin !== this.editedItem.remark) {
                editedField['remark'] = this.editedItem.remark;
              }
              this.paramItem['editItem'] = editedField;

              this.refeshList();
              await this.sendActivate(this.editedItem.id, 'EDI', editedField);

              this.$refs.ediIdDialog.dialog = true;
              this.checkDialogColor = 'success';
              this.checkDialogInfo = this.$t('msg.identification.saveModifyIdentification');
            });
          }
        } else {
          this.$store.dispatch('checkEdiId', this.editedItem).then(() => {
            const checkResult = this.$store.getters.chkEdiId;
            if (checkResult.srId !== undefined) {
              this.$refs.ediIdDialog.dialog = true;
              this.checkDialogColor = 'error';
              this.checkDialogInfo = 'This identification is duplicated.';
            } else {
              this.$store.dispatch('insertEdiId', this.editedItem).then(() => {
                // 2021.5.17 203728 Choose new EDI apply only for Workflow
                this.refeshList(this.editedItem);
                this.$refs.ediIdDialog.dialog = true;
                this.checkDialogColor = 'success';
                this.checkDialogInfo = this.$t('msg.identification.saveAddIdentification');
              });
            }
          });
        }
      }
      return validResult;
    },
  },
  created() {
    if (this.indexType > -1) {
      this.editedItem = this.paramItem;
      this.remarkOrigin = this.paramItem.remark;
      this.srIdOrigin = this.paramItem.srId;
      this.srQlfrLoad = this.paramItem.srQlfr;
      this.comp_ID = this.paramItem.compNm;
      this.prnr_ID = this.paramItem.prnrNm;
      this.type = this.comp_ID ? 'C' : 'P';
      this.$store
        .dispatch('getListUseInWorkflow', {
          type: 'EDI',
          value: this.editedItem.id,
        })
        .then((res) => {
          this.numOfUse = res.length > 0;
        });
    }

    const params = [];
    this.$store.dispatch('getApiCompanyList', params).then(() => {
      const listData = this.$store.getters.apicompanies;
      this.compList = [];
      for (let i = 0; i < listData.length; i += 1) {
        const comp = listData[i];
        comp.text = `${comp.compNm} (${comp.compId})`;
        comp.value = comp.compId;
        this.compList.push(comp);
      }
    });
    this.$store.dispatch('getPartnerList', params).then(() => {
      const listData = this.$store.getters.partnerList;
      this.prnrList = [];
      for (let i = 0; i < listData.length; i += 1) {
        const prnr = listData[i];
        prnr.text = `${prnr.prnrNm} (${prnr.prnrId})`;
        prnr.value = prnr.prnrId;
        this.prnrList.push(prnr);
      }
      // 2021.5.12 203728 Call from workflow
      if (this.partnerId) {
        this.comp_ID = this.partnerId;
        this.selectComp();
      }
    });
  },

  mounted() {
    /**
     * 2021.07.26 203737 SPKA-161 issue 110 Change all text field and combo box style for search condition [Management]
     * Check undefined for sr_id
     */
    if (this.$refs.sr_id) {
      setTimeout(() => {
        this.$refs.remark.focus();
      }, 100);
    }
  },
};
</script>
<style>
.v-dialog-1 .form-identification textarea {
  margin-top: 0px !important;
  /* max-height: 60px; */
  /* min-height: 60px; */
  font-size: 14px !important;
}
.form-identification .v-text-field {
  margin-top: 5px;
}
.form-identification input,
.form-identification .v-select__selections {
  max-height: 30px !important;
}
.theme--light .v-dialog-1 .form-identification textarea {
  color: #000000;
}
.theme--dark .v-dialog-1 .form-identification textarea {
  color: #ffffff;
  font-weight: bold;
}
.theme--dark .form-identification .v-select .v-select__selection--comma {
  color: #7d838d;
  font-size: 14px !important;
  font-weight: bold;
}
.theme--light .dialog-body .button-col.action-col {
  background-color: #ffffff;
}
</style>
